import { action } from 'mobx'
import { observer } from 'mobx-react-lite'
import type { FilterProps } from '@/infra/type-utils'
import {
  CheckboxInput,
  type CheckboxInputProps,
} from '@/components/inputs/CheckboxInput'
import type { ContainerProps } from '@/components/FormContainer'

/**
 * Form field container for a {@link CheckboxInput}, which lays out its own
 * label and help.
 */
export const CheckboxInputContainer = observer(function CheckboxInputContainer<
  M extends object,
  K extends keyof FilterProps<M, boolean>,
>({
  model,
  field,
  ...rest
}: Omit<
  ContainerProps<
    M,
    boolean,
    K,
    Omit<CheckboxInputProps, 'checked' | 'onChange'>
  >,
  'name' | 'sublabel'
>) {
  return (
    <CheckboxInput
      {...rest}
      checked={model[field] as boolean}
      onChange={action(`change ${field}`, (checked: boolean) => {
        model[field] = checked as M[K]
      })}
    />
  )
})
